import { instance } from '@/api/instances'

const fetchRefundCounterReferral = async (store, { id }) => {
  const personId = store.rootState.pillars.personId
  try {
    return await instance.get(
      `persons/${personId}/refund_counter_referral/${id}`
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'refund/fetchRefundCounterReferral' },
      { root: true }
    )
  }
}

const updateRefundCounterReferral = async (store, data) => {
  const personId = store.rootState.pillars.personId
  try {
    return await instance.put(
      `persons/${personId}/refund_counter_referral/${data.id}`,
      {
        json: data
      }
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'refund/updateRefundCounterReferral' },
      { root: true }
    )
  }
}

export default {
  fetchRefundCounterReferral,
  updateRefundCounterReferral
}
